import React from 'react';
import Skeleton from 'react-skeleton-loader';

export default ({ isPending, children, ...props }) => {
  return isPending ? <Skeleton borderRadius="4px" {...props} /> : children;
};
